import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "survey-item"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h2 class=\"p-4 is-size-4\"><ruby>何歳<rp>(</rp><rt>なんさい</rt><rp>)</rp></ruby>ですか？ </h2><div class=\"p-4 is-flex is-justify-content-center\"><p class=\"is-size-5\"> （9<ruby>歳<rp>(</rp><rt>さい</rt><rp>)</rp></ruby><ruby>以下<rp>(</rp><rt>いか</rt><rp>)</rp></ruby>の<ruby>場合<rp>(</rp><rt>ばあい</rt><rp>)</rp></ruby><ruby>画面<rp>(</rp><rt>がめん</rt><rp>)</rp></ruby>の<ruby>文字<rp>(</rp><rt>もじ</rt><rp>)</rp></ruby>がひらがなになります） </p></div>", 2)
const _hoisted_4 = { class: "p-4 columns is-multiline fade-in" }
const _hoisted_5 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isMultiChoices)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.ageWordList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "column is-one-fifth",
                  key: index
                }, [
                  _createElementVNode("button", {
                    class: "button is-info is-fullwidth",
                    onClick: ($event: any) => (_ctx.nextPage(_ctx.ageBaseValue + index)),
                    disabled: _ctx.isWhiteout
                  }, _toDisplayString(_ctx.ageBaseValue + index), 9, _hoisted_5)
                ]))
              }), 128))
            : (_ctx.isHundredAndOver)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
              : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}